<div 
  class="nav-item"
  [class.selected]="isSelected"
  (click)="onNavItemClick()"
>
  <span class="nav-item-text">{{ navItem.title }}</span>
</div>
